namespace advisorop.components.servicer {
    'use strict';
     
    export class NewManualAccountServicerController {
        $router;
        resetFormAfterPost: boolean = false;
        firm: domains.ICompanyGroup;
        step: number = 0;
        title: domains.ITitle;
        titles: Array<domains.ITitle> = [];
        investors: Array<domains.IInvestor> = [];
        // account 
        account: domains.IAccount = { id: 0, manualAccount: {} };
        ppAccount: domains.IPPAccountProfile;
        selTitleType: domains.ILOV;
        selTitleSubtype: domains.ILOV;
        selPremiumModel: domains.ILOV;
        selManualAccountHoldingType: domains.ILOV;
        // RTQ
        rtqs: Array<domains.IRTQ> = [];
        rtq: domains.IRTQ = {};

        lovs: Array<domains.ILOV> = [];
        titleTypes: Array<domains.ILOV> = [];
        titleSubtypes: Array<domains.ILOV> = [];
        premiumModels: Array<domains.ILOV> = [];
        manualAccountHoldingTypes: Array<domains.ILOV> = [];


        openAccountText: string = "Open Account"; //"Custodian"



        // statuses for ladda ...
        updatingAccountLadda: boolean = false;


        static $inject = ["generalService", "advisorService", "identityService", "servicerService", "$scope"];
        constructor(private generalService: services.GeneralService,
            private advisorService: services.AdvisorService,
            private identityService: services.IdentityService,
            private servicerService: services.ServicerService,
            private $scope: ng.IScope
        ) {
            
        };

        newInvestorSelected(investor: domains.IInvestor): void {
            var inv = this.investors.filter((v, i, a) => {
                return v.id == investor.id;
            });
            if (inv.length === 0)
                this.investors.push(investor);
            else
                toastr.warning("Investor already exists in the account list of investors.");
        };
        titleSelected(title: domains.ITitle): void {
            this.title = title;
        };


        reset(): void {
            this.account = {};
            var frm = <ng.IFormController>this.$scope["form.manualAccount"];
            frm.$submitted = true;
            frm.$setUntouched();
            frm.$setPristine();
         
        };


        getTitleSubtypes(titleType: number): Array<domains.ILOV> {
            return this.lovs.filter((v, i, a) => {
                return v.lovType == 11 && v.parentId == titleType;
            })
        };



        premiumModelChanged(): void {
            if (this.selPremiumModel) {
                this.account.manualAccount.premiumMode = this.selPremiumModel.value;
            }
            else {
                this.account.manualAccount.premiumMode = 0;
            }
        };

        manualAccountHoldingTypeChanged(): void {
            if (this.selManualAccountHoldingType) {
                this.account.manualAccount.manualAccountHoldingType = this.selManualAccountHoldingType.value;
            }
            else {
                this.account.manualAccount.manualAccountHoldingType = 0;
            }
        };

        //account Type
        titleTypeChanged(): void {

            if (this.selTitleType) {

                this.account.titleType = this.selTitleType.value;

                this.titleSubtypes = this.getTitleSubtypes(this.account.titleType);

                if (this.titleSubtypes.length > 0)
                    this.selTitleSubtype = this.titleSubtypes[0];
                else
                    this.selTitleSubtype = {
                        value: 99
                    };
            }
            else {
                this.account.titleType = 0;
                this.selTitleSubtype = {
                    value: 99
                };
            }
            this.titleSubtypeChanged();
        };

        //account subtype
        titleSubtypeChanged(): void {
            if (this.selTitleSubtype) {
                this.account.titleSubtype = this.selTitleSubtype.value;
            } else {
                this.account.titleSubtype = null;
            }
        };

        //remove individual
        removeInvestor(inv: domains.IInvestor): void {
            var ind = this.investors.indexOf(inv);
            if (ind >= 0)
                this.investors.splice(ind, 1);
        };

        goToAccounts() {
            this.$router.navigate(["AdvisorAccounts", { accountStatus: 0 }]);
        };

        //opening account
        openAccount(): ng.IPromise<void> {

            //open account ...
            this.account.titleId = 0;//this.title.id;
            this.account.titleName = "";//this.title.name;
            this.account.usdMarketValue = 0;
            this.account.status = 0;
            this.account.id = 0;
            this.account.investors = this.investors;

            this.account.manualAccount.id = 0;

            this.updatingAccountLadda = true;

            return this.servicerService.openAccount(this.account, this.advisorFirmId)
                .then((data) => {

                    if (this.account.manualAccount == null) {

                        this.account.advisoryFirmMgtRoleDescription = "MANAGED ACCOUNT";
                    }
                    else {
                        this.account.advisoryFirmMgtRoleDescription = "UNMANAGED ACCOUNT";

                    }
                    toastr.success("Account has been successfully registered.");

                    //this.$router.navigate(['AdvisorAccounts', { accountStatus: 0 }]);                    

                    //this.reset();

                    //this.account = data.data;
                  //  this.goToAccounts();

                })
                .finally(() => {
                    this.updatingAccountLadda = false;
                });
        };

        //updating account
        updateAccount(): void {

            this.updatingAccountLadda = true;

            this.advisorService.updateAccount(this.account)
                .success((data) => {

                    toastr.success("Account has been successfully updated.");

                    this.account = data;                    

                 //   this.$router.navigate(['AdvisorAccounts', { accountStatus: 0 }]);
                    
                })
                .error((status, data) => {
                    toastr.error("Error " + status + " " + data);
                    return;
                })
                .finally(() => {
                    this.updatingAccountLadda = false;
                });
        };




        //loading LOVs

        loadLovs(): void {
            this.generalService.getLOVs()
                .then((data) => {

                    this.lovs = data;

                    this.titleTypes = this.lovs.filter((value, index, array) => { return value.lovType == 10; });
                    this.premiumModels = this.lovs.filter((value, index, array) => { return value.lovType == 12; });
                    this.manualAccountHoldingTypes = this.lovs.filter((value, index, array) => { return value.lovType == 13; });

                }, (reason) => {
                    toastr.error("Error " + reason);
                });
        };


        //loading Account
        loadAccount(accountId: number): void {
            this.servicerService.getAccount(accountId)
                .then(data => {
                    
                    //console.log("Account data loaded... Binding account: " + data.data.name + " :" + data.data.id + " Type:" + data.data.titleType);

                    this.account = data.data;


                    this.investors = this.account.investors;

                    this.selTitleType = this.titleTypes.filter((v, i, a) => { return v.value == this.account.titleType })[0];

                    this.titleTypeChanged();

                    let tmp = this.titleSubtypes.filter((v, i, a) => { return v.value == this.account.titleSubtype });
                    if (tmp.length > 0)
                        this.selTitleSubtype = tmp[0];

                    //console.log("Account binding completed..." + this.account.name);
                })
                .catch(error => {
                    toastr.warning("Account error " + error.status + " " + error.data);
                });
        };

        loadPPAccount(ppAccountId: number): void {
            this.servicerService.getPPAccount(ppAccountId)
                .success((data) => {
                    //console.log("PP account data loaded...");
                    this.ppAccount = data;

                    this.account.number = this.ppAccount.accountID;
                    this.account.name = this.ppAccount.acctName;
                    this.account.titleName = this.ppAccount.acctName;

                })
                .error((status, data) => {
                    toastr.warning("PP Account error " + status + " " + data);
                });
        };



        //initializuation
        advisorFirmId: number;
        $onInit(): void {
            this.loadLovs();
        };

        $routerOnActivate(next, previous) {
            //console.log("ADvisory Firm ID in acc mapp servicer");
            //console.log(next.params.companyGroupId);
            if (next.params.accountId) {
                this.loadAccount(<number>next.params.accountId);

            }
            if (next.params.ppAccountId) {
                this.loadPPAccount(<number>next.params.ppAccountId);

            }
            if (next.params.companyGroupId) {
                this.advisorFirmId = next.params.companyGroupId;
            }

        }

    }



    class NewManualAccountServicer implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                "$router": "<",
                resetFormAfterPost: "@",
            };
            this.controller = ["generalService", "advisorService", "identityService", "servicerService", NewManualAccountServicerController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/new-manual-account-servicer.html';
        }
    }
    angular.module(Constants.APP).component("newManualAccountServicer", new NewManualAccountServicer());

}